import { ref } from "vue";

const isProgressShown = ref(false);
let countOfLoading = 0;
const WAIT_SLOW_LOADING = 300;

export function useProgressBarLoading() {
  let timeout;

  function _showProgress() {
    timeout = setTimeout(() => isProgressShown.value = true, WAIT_SLOW_LOADING);
  }

  function _removeProgress() {
    clearTimeout(timeout);
    isProgressShown.value = false;
  }

  function useComponentChunkWithProgressBar(chunkImportFn) {
    countOfLoading++;
    if (countOfLoading > 1) {
      _showProgress();
    }

    return chunkImportFn()
      .finally(() => {
        _removeProgress();
      });
  } 

  return {
    isProgressShown,
    useComponentChunkWithProgressBar,
  }
}